import React from "react";
import { Paper } from "Components/Base/Surfaces/Paper";
import CenteredPagination from "Components/Fragment/CenteredPagination";
import CourseCards from "./CourseCards";
import CourseList from "./CourseList";
import StateRenderer from "./StateRenderer";
import Toolbar from "./Toolbar";

const DesktopCourseContent = ({
  state,
  languageContext,
  resetFilters,
  shouldShowPagination,
  maxPages,
  setPage,
  filterButtonRef,
}) => {
  return (
    <Paper
      elevation={0}
      square
      sx={{
        padding: "0 !important",
        backgroundColor: state.listView
          ? "var(--backgroundPaper)"
          : "var(--colorBackground)",
      }}
    >
      <Toolbar
        languageContext={languageContext}
        filterButtonRef={filterButtonRef}
      />
      <StateRenderer
        state={state}
        languageContext={languageContext}
        resetFilters={resetFilters}
      />
      {state.listView ? (
        <CourseList languageContext={languageContext} />
      ) : (
        <CourseCards languageContext={languageContext} />
      )}
      {!!shouldShowPagination && (
        <CenteredPagination
          maxPages={maxPages}
          currentPage={state.page}
          onPageChange={setPage}
        />
      )}
    </Paper>
  );
};

export default DesktopCourseContent;
